import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Menu, X } from "lucide-react";
import { useState } from "react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function loginWithGoogle() {
  const redirect = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
}

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/jobs", label: "Jobs" },
    { to: "/employers", label: "Employers" },
    { to: "/industries", label: "Industries" },
    { to: "/ai-match", label: "AI Match" },
    { to: "/post-job", label: "Post a Job" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="w-8 h-8 bg-yellow-500 flex items-center justify-center relative">
            <div className="w-3 h-3 bg-black"></div>
            <div className="absolute inset-0 border border-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity"></div>
          </div>
          <span className="font-display text-xl tracking-tight uppercase">
            Discover<span className="text-yellow-500">Apprenticeship</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm font-medium text-zinc-400 hover:text-white tracking-wider uppercase transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <button
                data-testid="nav-dashboard-btn"
                onClick={() => navigate("/dashboard")}
                className="text-sm font-semibold text-white hover:text-yellow-500 uppercase tracking-wider"
              >
                {user.name?.split(" ")[0] || "You"}
              </button>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-sm text-zinc-500 hover:text-white uppercase tracking-wider"
              >
                Logout
              </button>
            </>
          ) : (
            <button
              data-testid="nav-login-btn"
              onClick={loginWithGoogle}
              className="text-sm font-bold uppercase tracking-wider bg-yellow-500 text-black px-5 py-2 hover:bg-yellow-400 active:scale-95 transition"
            >
              Sign In
            </button>
          )}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-800 bg-black">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-zinc-300 uppercase text-sm tracking-wider">
                {l.label}
              </Link>
            ))}
            {user ? (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)} className="text-white uppercase text-sm tracking-wider">Dashboard</Link>
                <button onClick={async () => { await logout(); setOpen(false); navigate("/"); }} className="text-zinc-500 uppercase text-sm tracking-wider text-left">Logout</button>
              </>
            ) : (
              <button onClick={loginWithGoogle} className="bg-yellow-500 text-black uppercase text-sm font-bold px-4 py-2">Sign In</button>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
